import { RefObject, useEffect } from 'react';

export const useKeyDown = (ref: RefObject<HTMLElement> | null, key: string, cb: () => void) => {
  useEffect(() => {
    const listener = (event: KeyboardEvent) => {
      if (event.key === key) {
        cb();
      }
    };

    document.addEventListener('keydown', listener);

    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [ref, cb, key]);
};
